import { motion } from 'framer-motion'

const className = 'container mc-mt-4 mc-mb-6'

export const Section = ({
  children,
  id = '',
  noAnimation = false,
}: {
  children: React.ReactNode
  id?: string
  noAnimation?: boolean
}) =>
  noAnimation ? (
    <section className={className} id={id}>
      <div className='mc-py-4'>{children}</div>
    </section>
  ) : (
    <motion.section
      className={className}
      id={id}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1.2, ease: 'easeOut', delay: 0.2 }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className='mc-py-4'>{children}</div>
    </motion.section>
  )
